import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="bg-gray-900 text-white px-6 py-4 flex justify-between items-center">
      <h2 className="text-xl font-bold">Zaanga Tech</h2>

      <div className="space-x-6 text-sm">
        <Link to="/" className="hover:text-gray-300">Home</Link>
        <Link to="/engineering" className="hover:text-gray-300">Engineering</Link>
        <Link to="/fabrication" className="hover:text-gray-300">Fabrication</Link>
        <Link to="/it-services" className="hover:text-gray-300">IT Services</Link>
        <Link to="/contact" className="bg-green-600 px-3 py-1 rounded hover:bg-green-700">
          Contact
        </Link>
      </div>
    </nav>
  );
}
